import automateTaxesIllustrationDE from 'assets/images/wallet-onboarding-automate-taxes-de.png';
import automateTaxesIllustrationFR from 'assets/images/wallet-onboarding-automate-taxes-fr.png';
import automateTaxesIllustrationNL from 'assets/images/wallet-onboarding-automate-taxes-nl.png';
import automateTaxesIllustration from 'assets/images/wallet-onboarding-automate-taxes.png';
import { Button } from 'components/atoms/Button';
import WalletPercentIcon from 'components/atoms/SVG/WalletPercentIcon.component';
import ModalHeading from 'components/molecules/ModalHeading/ModalHeading.component';
import { motion } from 'motion/react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fadeTransition } from 'utils/constants';

const automateTaxesImages: Record<string, string> = {
  en: automateTaxesIllustration,
  fr: automateTaxesIllustrationFR,
  nl: automateTaxesIllustrationNL,
  de: automateTaxesIllustrationDE,
};

const AutomaticallyReserveTaxes: FC<{ onConfirm?: () => void }> = ({
  onConfirm,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <motion.div
      {...fadeTransition}
      className="flex items-center justify-center flex-col relative pb-20"
      key="4"
    >
      <ModalHeading
        Icon={WalletPercentIcon}
        title={t('wallet.tutorial.slide_c.title.new')}
        subtitle={t('wallet.tutorial.slide_c.subtitle.new')}
        titleClassName="w-[80%]"
        subtitleClassName="w-[80%]"
      />

      <img src={automateTaxesImages[language]} className="w-[65%]" />

      <Button
        color="bank"
        className="mt-6 w-[80%] absolute bottom-0 capitalize"
        onClick={onConfirm}
      >
        {t('next')}
      </Button>
    </motion.div>
  );
};

export default AutomaticallyReserveTaxes;
